import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "./index";
import Uwp from "../../utils/uwp";
import { feedbackAction, elementAction, uwpAction } from "../../store";

class SelectFile {
  constructor(name, size, path) {
    this.name = name;
    this.size = size;
    this.extension = name.substring(name.lastIndexOf(".") + 1);
    this.path = path;
  }
}

export default function Uploader({ t, className }) {
  const theme = useSelector((state) => state.element.theme);
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [fileSize, setFileSize] = useState("0");
  const syncUploadFileContent = useSelector(
    (state) => state.uwp.syncUploadFileContent
  );
  const dispatch = useDispatch();
  const acceptFile = ["jpg", "png", "gif"].join(", ");
  const maxFiles = 5;

  useEffect(() => {
    if (syncUploadFileContent) {
      syncUwpSelectedFiles();
    }
  }, [syncUploadFileContent]);

  async function syncUwpSelectedFiles() {
    setFiles([]);
    setFileSize("0");
    const res = await Uwp.syncUwpSelectedFiles();
    dispatch(uwpAction.resetSyncUploadFileContent());
    checkFiles(res);
  }

  // function syncUwp

  // useEffect(() => {
  //   checkFiles();
  //   _changeFile();
  // }, [files]);

  function checkFiles(_files) {
    setFiles([]);
    const _maxSize = 10;
    const maxSize = _maxSize * 1024 * 1024; // 10MB

    const allowedTypes = ["jpg", "jpeg", "png", "gif"];
    let error = "";

    if (_files.length > maxFiles) {
      error += `最多只能上傳 ${maxFiles} 個檔案。\n`;
    }
    setFileSize("0");
    let size = 0;
    for (let i = 0; i < _files.length; i++) {
      const f = _files[i];
      const file = new SelectFile(f.fileName, f.fileSize, f.filePath);

      if (!allowedTypes.includes(file.extension)) {
        console.log("file.extension", file);
        error += `檔案 ${file.name} 格式不正確。\n`;
      }
      size += Number(file.size);
      if (file.size > maxSize) {
        error += `檔案 ${file.name} 超過 ${_maxSize}MB 的限制。\n`;
      }
      setFiles((prev) => [...prev, file]);
    }
    if (error) {
      // setFiles([]);
      dispatch(elementAction.triggerSubmitDialog(true));
      dispatch(feedbackAction.uploadFileError());
      dispatch(feedbackAction.setScreenShotCheck(false));
      console.log("error", error);
      return;
    }
    if (size > 0) {
      size = (size / 1024 / 1024).toFixed(2);
      setFileSize(size);
      console.log(`檔案總大小: ${size}MB`);
      if (size > _maxSize) {
        dispatch(elementAction.triggerSubmitDialog(true));
        dispatch(feedbackAction.uploadFileError());
        dispatch(feedbackAction.setScreenShotCheck(false));
        console.log(`檔案大小超過 ${_maxSize}MB 的限制。`);
        return;
      }
    }
    dispatch(feedbackAction.setScreenShotCheck(true));
  }

  function handleFileChange(event) {
    const _files = event.target.files;
    const fileArray = Array.from(_files).map((file) => file);
    setFiles(fileArray);
  }

  function detectFileSize(_files) {
    let size = 0;
    _files.forEach((file) => {
      size += Number(file.size);
    });
    size = (size / 1024 / 1024).toFixed(2);
    setFileSize(size);
  }

  // async function _changeFile() {
  //   await Uwp.updateScreenshot(files);
  // }

  function handleUpload() {
    Uwp.triggerSelectedFiles();
    setFiles([]);
    // fileInputRef.current.click();
  }

  function removeFile(file) {
    const f = files.filter((f) => f !== file).map((f) => f.path);
    // setFiles((prev) => f);
    // detectFileSize(f);
    Uwp.updateFiles(f);
  }

  return (
    <>
      <div className={`text-${theme}-normal flex space-x-5 items-center`}>
        <p className={`text-${theme}-normal input-text`}>
          {t("upload_screen_shot")}
        </p>
        <p className={`mt-2 text-sm text-${theme}-disabled`}>
          {t("upload_screen_shot_desc")}
          {/* {t("file_format")} /{" "}
          {t("file_size", {
            size: 10,
          })} */}
        </p>
      </div>
      <div
        className={`rounded-md flex flex-col mt-5 relative min-h-[40px] border-[1px] border-${theme}-normal`}
      >
        <input
          type={"file"}
          ref={fileInputRef}
          className={"hidden"}
          onChange={handleFileChange}
          multiple
          accept={acceptFile}
        />
        {/* <div className="inset-0" aria-hidden={"true"}>
          <div className="absolute w-2 h-2 left-0 top-0 border-t-[1.5px] border-l-[1.5px]"></div>
          <div className="absolute w-2 h-2 left-0 bottom-0 border-b-[1.5px] border-l-[1.5px]"></div>
          <div className="absolute w-2 h-2 right-0 bottom-0 border-b-[1.5px] border-r-[1.5px]" />
        </div> */}
        <div
          className={`rounded-md min-h-[50px] h-full w-full text-xl text-[22px] pl-[5px] input-text text-${theme}-normal flex flex-row ${className} border-b-[1px] border-${theme}-focus flex-wrap`}
        >
          <span className="corner-b-l-uploader" aria-hidden="true" />
          <span className="corner-b-r-uploader" aria-hidden="true" />
          {files.map((file, index) => (
            <SingleFile
              key={index}
              theme={theme}
              file={file}
              onRemove={removeFile}
            />
          ))}
        </div>
      </div>
      <div className={"flex justify-between pt-2"}>
        <Button
          id="add_files"
          className={`h-[40px] w-[250px] ${className}`}
          theme={theme}
          onClick={handleUpload}
          isFocus={(name) => false}
          isEnabled={true}
        >
          {t("add_files")}
        </Button>
        <p className={`text-${theme}-disabled text-sm mt-2`}>
          {t("max_attachment_number", {
            fileLength: files.length,
            maxLength: maxFiles,
          })}
        </p>
      </div>
    </>
  );
}

const SingleFile = ({ className, theme, file, onRemove }) => {
  function _remove() {
    onRemove(file);
  }

  async function previewFile() {
    await Uwp.previewScreenshot(file);
  }

  return (
    <div
      className={`rounded-md flex space-x-3 min-w-[120px] min-h-[32px] px-5 my-2 mx-[5px] align-middle text-center justify-center items-center text-sm ${className} border-[1px] border-${theme}-normal`}
    >
      <span
        className="h-full flex items-center justify-center"
        onClick={previewFile}
      >
        {file.name}
      </span>
      <svg
        onClick={_remove}
        className={"z-[999]"}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.646667 1.35359L1.35377 0.646484L8.00058 7.29329L14.6474 0.646487L15.3545 1.35359L8.70769 8.0004L15.3545 14.6472L14.6474 15.3543L8.00058 8.7075L1.35377 15.3543L0.646667 14.6472L7.29347 8.0004L0.646667 1.35359Z"
          fill="#F2F2F2"
        />
      </svg>
    </div>
  );
};
